import { Outlet, Navigate } from "react-router-dom";

const CareerAssessmentLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default CareerAssessmentLayout;
